import styled from "styled-components";

const NewArrivalContainer = styled.div`
  margin-bottom: 100px;

  @media (max-width: 575px) {
    margin-bottom: 50px !important;
  }

  @media (max-width: 1199px) {
    margin-bottom: 70px;
  }
`;
export default NewArrivalContainer;
